import type { FunctionComponent } from 'react';

import { useFeatureGate } from '@trello/feature-gate-client';

import { LazyPowerUpApiKeyPage } from './PowerUpApiKeyPage/components/LazyPowerUpApiKeyPage';
import { PowerUpPageNavigation } from './Navigation';
import { PowerUpBasicInformationPage } from './PowerUpBasicInformationPage';
import { PowerUpCapabilitiesPage } from './PowerUpCapabilitiesPage';
import { PowerUpCollaboratorsPage } from './PowerUpCollaboratorsPage';
import { PowerUpDeletePage } from './PowerUpDeletePage';
import { PowerUpDistributionPage } from './PowerUpDistributionPage';
import { PowerUpListingsPage } from './PowerUpListingsPage';
import { PowerUpMetricsPage } from './PowerUpMetricsPage';
import { PowerUpOAuth2Page } from './PowerUpOAuth2Page';
import { PowerUpPrivacyAndCompliancePage } from './PowerUpPrivacyAndCompliancePage';

import styles from './PowerUpPage.less';

export const PowerUpPage: FunctionComponent<{
  idPlugin: string;
  subsection?: string | null;
}> = ({ idPlugin, subsection }) => {
  const { value: useHorseflyDevPortal } = useFeatureGate(
    'goo_horsefly_dev_portal',
  );

  let PageComponent;
  switch (subsection) {
    case 'api-key':
      PageComponent = LazyPowerUpApiKeyPage;
      break;
    case 'oauth2':
      if (useHorseflyDevPortal) {
        PageComponent = PowerUpOAuth2Page;
      } else {
        PageComponent = PowerUpBasicInformationPage;
      }
      break;
    case 'capabilities':
      PageComponent = PowerUpCapabilitiesPage;
      break;
    case 'privacy':
      PageComponent = PowerUpPrivacyAndCompliancePage;
      break;
    case 'listings':
      PageComponent = PowerUpListingsPage;
      break;
    case 'delete':
      PageComponent = PowerUpDeletePage;
      break;
    case 'distribution':
      PageComponent = PowerUpDistributionPage;
      break;
    case 'metrics':
      PageComponent = PowerUpMetricsPage;
      break;
    case 'collaborators':
      PageComponent = PowerUpCollaboratorsPage;
      break;
    default:
      PageComponent = PowerUpBasicInformationPage;
  }

  return (
    <>
      <PowerUpPageNavigation idPlugin={idPlugin} subsection={subsection} />
      <div className={styles.content}>
        <PageComponent idPlugin={idPlugin} />
      </div>
    </>
  );
};
